<div class="row">
  <div class="col-md-12">
    <app-card>
      <div class="row">
        <div class="col-md-12 col-xl-12 md-tabs">
          <div class="mb-1">
            <div class="row flex-align-items">
              <div
                [hidden]="
                  adminClusterView || !userFeatures.has(ACL_SITE_EDIT) || !auth.currentOrganization.clusters.length
                "
                style="margin: 0 15px"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-primary waves-effect"
                  (click)="addSite()"
                  style="margin: 10px 0"
                >
                  <i class="icofont icofont-plus"></i>
                  <span [innerHTML]="'AjouterUnSite' | translate"></span>
                </button>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>Cluster</label>
                  <select
                    [(ngModel)]="filters.clusterUid"
                    (ngModelChange)="filters.tag = undefined; refreshSites()"
                    class="form-control form-control-sm"
                  >
                    <option [ngValue]="undefined">{{ 'All' | translate }}</option>
                    <option *ngFor="let cluster of clusters" [ngValue]="cluster.uid">{{ cluster.name }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ 'Statut' | translate }}</label>
                  <select
                    [(ngModel)]="filters.status"
                    (ngModelChange)="refreshSites()"
                    class="form-control form-control-sm"
                  >
                    <option [ngValue]="undefined">{{ 'All' | translate }}</option>
                    <option *ngFor="let status of siteStatuses" [ngValue]="status.code">{{ status.label }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-2" *ngIf="!adminClusterView">
                <div class="form-group">
                  <label>Tag</label>
                  <select
                    [(ngModel)]="filters.tag"
                    (ngModelChange)="refreshSites()"
                    class="form-control form-control-sm"
                  >
                    <option [ngValue]="undefined">{{ 'All' | translate }}</option>
                    <option *ngFor="let tag of tags" [ngValue]="tag">{{ tag }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>{{ 'Search' | translate }}</label>
                  <input
                    id="search"
                    #searchInputRef
                    [(ngModel)]="filters.search"
                    type="text"
                    placeholder="{{ 'Sites.search.placeHolder' | translate }}"
                    class="form-control form-control-sm"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-striped table-condensed" style="border: 1px solid #ccc">
              <thead>
                <tr>
                  <th class="select"></th>
                  <th class="status">
                    {{ 'Statut' | translate }}
                    <app-help tooltipKey="StatusIs" tooltipPlacement="top" />
                  </th>
                  <th class="name">
                    {{ 'Site' | translate }}
                  </th>
                  <th class="cluster">
                    {{ 'Cluster' | translate }}
                    <app-help tooltipKey="ClusterIs" tooltipPlacement="top" />
                  </th>
                  <th class="originServer">
                    {{ 'DestinationIp' | translate }}
                    <app-help tooltipKey="DestinIs" tooltipPlacement="top" />
                  </th>
                  <th *ngIf="adminClusterView" class="owner">
                    {{ 'Owner' | translate }}
                  </th>
                  <th class="createdAt">
                    {{ 'Creation' | translate }}
                  </th>
                  <th *ngIf="adminClusterView" [innerHtml]="'Site.TableHeader.DdosProtection' | translate"></th>
                  <th *ngIf="adminClusterView">
                    {{ 'Mode' | translate }}
                    <app-help tooltipKey="ModeTooltip" tooltipPlacement="bottom" />
                  </th>
                  <th class="actions">
                    {{ 'Actions' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngIf="!sites.length">
                  <td [attr.colspan]="adminClusterView ? 10 : 8" style="text-align: center">
                    {{ 'NoData' | translate }}
                  </td>
                </tr>
                <tr
                  *ngFor="
                    let row of sites
                      | paginate
                        : {
                            itemsPerPage: pageSize,
                            currentPage: index + 1,
                            totalItems: total,
                          }
                  "
                >
                  <td>
                    <label class="ogo-checkbox-container" *ngIf="adminClusterView || row.canDoMoreThanView">
                      <input
                        type="checkbox"
                        [checked]="selectedSites().has(row.domainName)"
                        (click)="toggleSelected($event, row)"
                      />
                      <span class="ogo-checkbox-checkmark"></span>
                    </label>
                  </td>
                  <td class="status">
                    <div class="status-cell">
                      <app-site-status [status]="row.status" />

                      @if (row.cdn) {
                        <app-activation-cdn-label [cdnStatus]="row.cdnStatus" />
                      }

                      @if (row.auditMode === true) {
                        <app-audit-mode-label />
                      }

                      @if (row.passthroughMode === true) {
                        <app-site-passthrough-mode-label />
                      }

                      @if (row.isACertificateInError) {
                        <app-certificate-error-label [errorMessage]="row.errorMessage" />
                      }
                    </div>
                  </td>
                  <td class="siteName">
                    <app-host-mode-label [siteMode]="row.mode" />

                    <app-managed-service-label [managed]="row.managed" />

                    @if (row.canEdit) {
                      <a class="site-config" title="{{ 'Configuration' | translate }}" (click)="editSite(row.domainName)">{{ row.domainName }}</a>
                    } @else {
                      <span>{{ row.domainName }}</span>
                    }
                    <a class="ogo-link" target="_blank" [href]="row.originScheme + '://' + row.domainName">
                      <i class="icofont icofont-external-link ml-2"></i>
                    </a>
                  </td>
                  <td>
                    {{ row.cluster.name }}
                  </td>
                  <td>
                    {{ row.originScheme }}://{{
                      isValidIpv6(row.originServer) ? '[' + row.originServer + ']' : row.originServer
                    }}{{ row.originPort ? ':' + row.originPort : '' }}
                  </td>
                  <td *ngIf="adminClusterView" [title]="row.owner.name + ' (' + row.owner.code + ')'">
                    <span> {{ row.owner.name }} </span>
                    <app-badge-organization [code]="row.owner.code"></app-badge-organization>
                  </td>
                  <td>
                    <app-timestamp-cell [value]="row.createdAt" />
                  </td>
                  <th *ngIf="adminClusterView">
                    <label class="ogo-checkbox-container">
                      <input type="checkbox" [(ngModel)]="row.ddosProtection" (click)="toggleDdosProtection(row)" />
                      <span class="ogo-checkbox-checkmark"></span>
                    </label>
                  </th>
                  <td *ngIf="adminClusterView" style="padding: 5px 10px !important">
                    <select
                      [ngModel]="row.mode"
                      (change)="setMode(row, $event)"
                      class="form-control"
                      style="font-weight: normal; min-width: 105px"
                    >
                      <option *ngFor="let m of hostModeService.modes" [value]="m.value">
                        {{ m.label | translate }}
                      </option>
                    </select>
                  </td>
                  <td class="actions">
                    <i
                      class="icon icon-reload"
                      [ngClass]="{ disabled: !row.canEdit || row.domainName == refreshingSite }"
                      style="transition: color 0.5s linear"
                      title="{{ 'RafraichirStatutHote' | translate }}"
                      (click)="row.canEdit && row.domainName != refreshingSite && refreshStatus(row)"
                    ></i>
                    <span
                      class="icon-container"
                      [ngClass]="{ disabled: !row.canShare }"
                      (click)="row.canShare && showSharedHosts(row)"
                    >
                      <i title="{{ 'MesPartages' | translate }}" [ngClass]="['icofont', 'icofont-share']"></i>
                      <sup *ngIf="row.nbShares && row.canShare" class="badge1"
                        >{{ row.nbShares <= 9 ? row.nbShares : 9 }}<sup *ngIf="row.nbShares > 9">+</sup></sup
                      >
                    </span>
                    <a [ngClass]="{ disabled: !row.canEdit }" (click)="row.canEdit && editSite(row.domainName)">
                      <i
                        id="{{ row.domainName + '-settings' }}"
                        title="{{ 'Configuration' | translate }}"
                        class="icon icon-settings"
                      ></i
                    ></a>
                    <i
                      title="{{ 'SeeSiteLogs' | translate }}"
                      (click)="track(row.cluster.name, [row.domainName])"
                      class="icon icon-search"
                    ></i>
                    <i
                      title="{{ 'supprimer' | translate }}"
                      [attr.name]="row.domainName + '-delete'"
                      (click)="row.canDelete && showModalDelete(row)"
                      class="icofont icofont-ui-delete"
                      [ngClass]="{ disabled: !row.canDelete }"
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
            <div *ngIf="sites.length" class="flex-align-items float-left" style="margin-top: 10px; margin-left: 10px">
              <a class="ogo-link mr-3" style="font-weight: bold" (click)="selectAll()">{{ 'SelectAll' | translate }}</a>
              <div class="icon-container">
                <i
                  title="{{ 'AuditPanic' | translate }}"
                  [ngClass]="canMultipleEdit() ? [] : ['disabled']"
                  (click)="canMultipleEdit() && modalMultipleAuditPanic.show()"
                  class="icon icon-settings"
                ></i>
                <i
                  title="{{ 'PartageMultiple' | translate }}"
                  [ngClass]="canMultipleShare() ? [] : ['disabled']"
                  (click)="canMultipleShare() && showModalMultipleShares()"
                  class="icofont icofont-share"
                ></i>
                <i
                  title="{{ 'SuppressionMultiple' | translate }}"
                  [ngClass]="canMultipleDelete() ? [] : ['disabled']"
                  (click)="canMultipleDelete() && modalMultipleDeletes.show()"
                  class="icofont icofont-ui-delete"
                ></i>
                <i
                  title="{{ 'CertificatMultiple' | translate }}"
                  [ngClass]="canMultipleEdit() ? [] : ['disabled']"
                  (click)="canMultipleEdit() && modalMultipleCertificat.show()"
                  class="icofont icofont-papers"
                ></i>
                <i
                  title="{{ 'TagsMultiple' | translate }}"
                  [ngClass]="canMultipleEdit() ? [] : ['disabled']"
                  (click)="canMultipleEdit() && modalMultipleTags.show()"
                  class="icofont icofont-tags"
                ></i>
                <i
                  title="{{ 'RefreshMultiple' | translate }}"
                  [ngClass]="selectedSites().size && !sitesInRefresh ? [] : ['disabled']"
                  (click)="selectedSites().size && !sitesInRefresh && multipleRefreshStatus()"
                  class="icon icon-reload"
                ></i>
                <i
                  title="{{ 'SeeSiteLogsMultiple' | translate }}"
                  [ngClass]="selectedSites().size && isSameCluster() ? [] : ['disabled']"
                  (click)="selectedSites().size && isSameCluster() && multipleSetSites()"
                  class="icon icon-search"
                ></i>
              </div>
            </div>
            <div class="flex-align-items pull-right">
              <div class="sites-total mr-3">Total : {{ total }}</div>
              <pagination-controls
                style="margin-top: 10px"
                *ngIf="sites.length"
                (pageChange)="changePage($event)"
                previousLabel="{{ 'Previous' | translate }}"
                nextLabel="{{ 'Next' | translate }}"
              ></pagination-controls>
            </div>
          </div>
        </div>
      </div>
    </app-card>
  </div>
</div>

<app-modal-basic #modalShare>
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{ 'MesPartages' | translate }} /
      <small class="text-primary">{{ selectedSite?.domainName }}</small>
      <app-help class="ml-1" hrefKey="ExternalHelp.share" />
    </h4>
    <button type="button" class="close basic-close" (click)="modalShare.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p class="mb-0" [innerHTML]="'PartagerSite' | translate"></p>
    <div class="group flex-align-items space-between mb-3 ng-select-no-dropdown">
      <div style="flex-basis: 80%">
        <ng-select
          #addShareInput
          (paste)="onPasteShare($event)"
          class="select-site-selector"
          [multiple]="true"
          [addTag]="true"
          [(ngModel)]="shareInput"
          [clearable]="false"
          [searchable]="true"
          [openOnEnter]="false"
          [closeOnSelect]="true"
          [placeholder]="'EnterEmailOrOrganizationCode' | translate"
          [inputAttrs]="{ 'data-form-type': 'other' }"
          (focus)="shareTooltip = true"
          (blur)="shareTooltip = false; handleShareBlur()"
          (search)="handleShareType($event)"
        ></ng-select>
      </div>
      <button
        (click)="confirmCreateShare()"
        [disabled]="!shareInput.length"
        class="create-share btn btn-sm btn-primary"
      >
        {{ 'Partager' | translate }}
      </button>
    </div>

    @if (shareTooltip) {
      <div style="margin-top: -10px; margin-bottom: 10px; font-size: 12px; color: #969696">
        <i>{{ 'PressEnterToAdd' | translate }}{{ 'SeparatedEmailsOrOrganizationsCodes' | translate }}</i>
      </div>
      <div class="warning">
        <span>{{ 'EnterEmailWarning' | translate }}</span>
      </div>
    }
    <div class="form-radio">
      <form>
        <ng-container *ngFor="let role of shareRoles">
          <div class="radio radiofill radio-inline">
            <label class="mt-1">
              <input [(ngModel)]="sharedRole" [value]="role" name="radio" type="radio" />
              <i class="helper"></i>
              <label-share-role [role]="role" />
              {{ 'ShareSite.' + role + '.description' | translate }}
            </label>
          </div>
        </ng-container>
      </form>
    </div>
    <br />
    <b>{{ 'Liste des partages actifs' | translate }}</b>
    <div class="share-list custom-scrollbar">
      <table *ngIf="currentShares.length" class="table table-xs table-bordered" style="margin-top: 10px">
        <tbody>
          <tr *ngFor="let share of currentShares; let i = index">
            <td class="flex-align-items">
              <div class="flex-align-items wrap" style="flex-basis: 50%; min-width: 0">
                <div [title]="share.recipient.name" class="text-ellipsis">
                  {{ share.recipient.name }}
                </div>
                <app-badge-organization [code]="share.recipient.code"></app-badge-organization>
              </div>
              <div class="ml-2">
                <label-share-role [role]="share.role" />
              </div>
              <i
                (click)="deleteShare(selectedSite.domainName, share.recipient.code, i)"
                style="color: #e74c3c; font-size: 20px; margin-left: auto"
                class="icofont icofont-ui-delete"
              ></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <p *ngIf="!currentShares.length" class="grey-disable">
      {{ 'AucunPartageActifPourLeMoment' | translate }}
    </p>
  </div>
  <div class="app-modal-footer">
    <button (click)="modalShare.hide()" class="btn btn-sm btn-danger">
      {{ 'Fermer' | translate }}
    </button>
  </div>
</app-modal-basic>

<app-modal-basic #modalDelete class="modal-delete-site">
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'deleteSite' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalDelete.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <form>
      <div class="form-group">
        <label>{{ 'Site' | translate }} :</label>
        <input type="text" value="{{ siteToDelete?.domainName }}" class="form-control form-control-sm" readonly />
      </div>
      <div class="form-group">
        <label>Cluster :</label>
        <input
          type="text"
          value="{{ siteToDelete?.cluster?.name }}"
          class="form-control form-control-sm"
          readonly
        />
      </div>
      <div class="form-group">
        <label>{{ 'DestinationIp' | translateLabel }}</label>
        <input type="text" value="{{ siteToDelete?.originServer }}" class="form-control form-control-sm" readonly />
      </div>
      <div *ngIf="siteToDelete?.certificates?.length" class="form-group">
        <label>{{ 'CertificatSsl' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.certificates?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.urlExceptions?.length" class="form-group">
        <label>{{ 'URLExceptions' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.urlExceptions?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.shares?.length > 0" class="form-group">
        <label>{{ 'Partages' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.shares?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.ipExceptions?.length" class="form-group">
        <label>{{ 'BlacklistedIps.title' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.ipExceptions?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.blacklistedIps?.length" class="form-group">
        <label>{{ 'BlacklistedIps.title' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.blacklistedIps?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.rules?.length" class="form-group">
        <label>{{ 'RulesManagement' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.rules?.length }}</strong>
      </div>
      <div *ngIf="siteToDelete?.rewriteRules?.length" class="form-group">
        <label>{{ 'RewriteRules' | translateLabel }}</label>
        &nbsp;<strong>{{ siteToDelete?.rewriteRules?.length }}</strong>
      </div>
      <div class="form-group form-check">
        <input
          id="confirm-delete"
          type="checkbox"
          name="check-delete"
          [(ngModel)]="confirmDelete"
          style="width: inherit"
          class="form-check-input"
        />
        <label for="confirm-delete" class="form-check-label">{{ 'ConfirmSuppreSite' | translate }}</label>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button
      [disabled]="!confirmDelete"
      name="validate-delete"
      (click)="deleteSite(siteToDelete.domainName)"
      class="btn btn-primary btn-sm"
      [innerHTML]="'delete' | translate"
    ></button>
    &nbsp;
    <button (click)="modalDelete.hide()" class="btn btn-danger btn-sm" [innerHTML]="'Fermer' | translate"></button>
  </div>
</app-modal-basic>

<app-modal-basic #modalMultipleAuditPanic>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'AuditPanic' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalMultipleAuditPanic.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <ul class="multiple-action-table-container custom-scrollbar">
      @for(entry of selectedSites() | keyvalue; track entry.value.domainName) {
        @let row = entry.value;
        <li>
          {{ row.domainName }}
          <b
            class="mode-letter"
            title="{{ 'PanicMode' | translate }}"
            (click)="toggleSiteBooleanProp(row, 'passthroughMode')"
            [ngStyle]="{
                        color: row.passthroughMode ? '#0e6efd' : '#8c8e92',
                      }"
          >{{ 'Panic' | translate }}</b
          >
          <b
            class="mode-letter"
            title="{{ 'AuditMode' | translate }}"
            (click)="toggleSiteBooleanProp(row, 'auditMode')"
            [ngStyle]="{
                        color: row.auditMode ? '#0e6efd' : '#8c8e92',
                      }"
          >Audit</b
          >
        </li>
      }
    </ul>
    <div style="margin-bottom: 30px">
      <button
        [disabled]="allEnabled('auditMode', false)"
        (click)="updateSelectedSitesBooleanProp('auditMode', false)"
        class="btn btn-primary btn-mini pull-right"
        [innerHTML]="'ToutEnleverModeAudit' | translate"
        style="margin: 5px"
      ></button>
      <button
        [disabled]="allEnabled('auditMode', true)"
        (click)="updateSelectedSitesBooleanProp('auditMode', true)"
        class="btn btn-primary btn-mini pull-right"
        [innerHTML]="'ToutPasserModeAudit' | translate"
        style="margin: 5px"
      ></button>
    </div>
    <div>
      <button
        [disabled]="allEnabled('passthroughMode', false)"
        (click)="updateSelectedSitesBooleanProp('passthroughMode', false)"
        class="btn btn-primary btn-mini pull-right"
        [innerHTML]="'ToutEnleverModePanic' | translate"
        style="margin: 5px"
      ></button>
      <button
        [disabled]="allEnabled('passthroughMode', true)"
        (click)="updateSelectedSitesBooleanProp('passthroughMode', true)"
        class="btn btn-primary btn-mini pull-right"
        [innerHTML]="'ToutPasserModePanic' | translate"
        style="margin: 5px"
      ></button>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      (click)="modalMultipleAuditPanic.hide()"
      style="margin-top: 5px; margin-right: 5px"
      class="btn btn-danger btn-sm pull-right"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>

<app-modal-basic #modalMultipleShares>
  <div class="app-modal-header">
    <h4 class="modal-title">
      {{ 'PartageMultiple' | translate }}
      <app-help hrefKey="ExternalHelp.share" />
    </h4>
    <button type="button" class="close basic-close" (click)="closeMultipleShares()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p [innerHTML]="'PartagerSites' | translate"></p>
    <ul class="multiple-action-table-container custom-scrollbar">
      @for (entry of selectedSites() | keyvalue; track entry.value.domainName) {
        @let row = entry.value;
        @if (hostModeService.isAdvanced(row.mode) && row.accessRights.includes('SHARE')) {
          <li>{{ row.domainName }}</li>
        }
      }
    </ul>
    <div class="group flex-align-items space-between mb-3 ng-select-no-dropdown">
      <div style="flex-basis: 80%">
        <ng-select
          #addMultiShareInput
          (paste)="onPasteShare($event)"
          class="select-site-selector"
          [multiple]="true"
          [addTag]="true"
          [(ngModel)]="shareInput"
          [clearable]="false"
          [openOnEnter]="false"
          [closeOnSelect]="true"
          [searchable]="true"
          [placeholder]="'EnterEmailOrOrganizationCode' | translate"
          [inputAttrs]="{ 'data-form-type': 'other' }"
          (focus)="shareTooltip = true"
          (blur)="$event.preventDefault(); shareTooltip = false; handleShareBlur()"
          (search)="handleShareType($event)"
        ></ng-select>
      </div>
      <button (click)="allCreateShare()" [disabled]="!shareInput.length" class="btn btn-sm btn-primary">
        {{ 'Partager' | translate }}
      </button>
    </div>
    @if (shareTooltip) {
      <div style="margin-top: -10px; margin-bottom: 10px; font-size: 12px; color: #969696">
        <i>{{ 'PressEnterToAdd' | translate }}{{ 'SeparatedEmailsOrOrganizationsCodes' | translate }}</i>
      </div>
      <div class="warning">
        <span>{{ 'EnterEmailWarning' | translate }}</span>
      </div>
    }
    <div class="form-radio" style="margin-top: 20px">
      <form>
        <ng-container *ngFor="let role of shareRoles">
          <div class="radio radiofill radio-inline">
            <label class="mt-1">
              <input [(ngModel)]="multipleSharedRole" [value]="role" name="radio" type="radio" />
              <i class="helper"></i>
              <span class="label {{ 'share-' + role }}" style="padding: 4px 9px">{{
                  'ShareSite.' + role + '.label' | translate
                }}</span>
              {{ 'ShareSite.' + role + '.description' | translate }}
            </label>
          </div>
        </ng-container>
      </form>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      (click)="closeMultipleShares()"
      style="margin-top: 5px; margin-right: 5px"
      class="btn btn-danger btn-sm pull-right"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>

<app-modal-basic #modalMultipleDeletes>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'SuppressionMultiple' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalMultipleDeletes.hide(); confirmDelete = false">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'DeleteSites' | translate }}</p>
    <ul class="multiple-action-table-container custom-scrollbar">
      @for (entry of selectedSites() | keyvalue; track entry.value.domainName) {
        <li>{{ entry.value.domainName }}</li>
      }
    </ul>
    <div class="form-group form-check">
      <input
        id="confirm-multiple-delete"
        type="checkbox"
        [(ngModel)]="confirmDelete"
        style="width: inherit"
        class="form-check-input"
      />
      <label for="confirm-multiple-delete" class="form-check-label">{{ 'ConfirmSuppreSites' | translate }}</label>
    </div>
  </div>
  <div class="app-modal-footer">
    <button
      [disabled]="!confirmDelete"
      (click)="allDelete()"
      class="btn btn-primary btn-sm"
      [innerHTML]="'DeleteDomains' | translate"
    ></button>
    <button
      (click)="modalMultipleDeletes.hide(); confirmDelete = false"
      class="btn btn-danger btn-sm"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>

<app-modal-basic #modalMultipleCertificat>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'CertificatMultiple' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalMultipleCertificat.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'ImportForSites' | translate }}</p>
    <ul class="multiple-action-table-container custom-scrollbar">
      @for (entry of selectedSites() | keyvalue; track entry.value.domainName) {
        @let row = entry.value;
        <li>{{ row.domainName }}</li>
      }
    </ul>
    <div class="form-group bg-orange p-2">
      {{ 'DoNotForgetConcatIntermediates' | translate }}
    </div>
    <form>
      <div class="form-group">
        <label>{{ 'PKCS12File' | translate }}</label>
        <div class="">
          <button (click)="loadPkcs12.click()" class="btn btn-block btn-primary btn-sm">
            {{ 'ImportPKCS12' | translate }}
            <input
              #loadPkcs12
              id="loadPkcs12"
              type="file"
              name="loadPkcs12"
              accept=".p12,.pfx"
              hidden
              (change)="handlePkcs12($event.target.files)"
              multiple="false"
            />
          </button>
          <p *ngIf="p12File">
            <small class="text-primary">{{ p12File.name }}</small>
          </p>
        </div>
      </div>
      <div class="form-group">
        <label>{{ 'MotDePasse' | translate }}</label>
        <input
          type="password"
          [(ngModel)]="p12Password"
          (keydown.enter)="handleKeyEnterP12($event)"
          name="p12Password"
          class="form-control form-control-sm"
        />
      </div>
      <div class="form-group flex-align-items">
        <input
          type="checkbox"
          [(ngModel)]="makeCertificateActive"
          id="makeCertificateActive"
          name="makeCertificateActive"
        />
        <label class="form-check-label" for="makeCertificateActive" style="margin-left: 5px">{{
            'MakeCertificateActive' | translate
          }}</label>
      </div>
    </form>
  </div>
  <div class="app-modal-footer">
    <button
      (click)="uploadP12()"
      class="btn btn-primary btn-sm"
      [disabled]="!p12File || !p12Password"
      [innerHTML]="'Import' | translate"
    ></button>
    <button
      (click)="modalMultipleCertificat.hide()"
      class="btn btn-danger btn-sm"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>

<app-modal-basic #modalMultipleTags>
  <div class="app-modal-header">
    <h4 class="modal-title">{{ 'TagsMultiple' | translate }}</h4>
    <button type="button" class="close basic-close" (click)="modalMultipleTags.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="app-modal-body">
    <p>{{ 'TagsMultipleDesc' | translate }}</p>
    <ul class="multiple-action-table-container custom-scrollbar">
      @for (entry of selectedSites() | keyvalue; track entry.value.domainName) {
        @let row = entry.value;
        <li>{{ row.domainName }}</li>
      }
    </ul>
    <app-site-tags [tags]="tags" (selectedChange)="pushTags($event)"></app-site-tags>
  </div>
  <div class="app-modal-footer">
    <button
      (click)="createTags()"
      class="btn btn-primary btn-sm"
      [disabled]="!selectedTags.length"
      [innerHTML]="'ToTag' | translate"
    ></button>
    <button
      (click)="modalMultipleTags.hide()"
      class="btn btn-danger btn-sm"
      [innerHTML]="'Fermer' | translate"
    ></button>
  </div>
</app-modal-basic>
